import { isAddress } from '@ethersproject/address'
import { useMemo } from 'react'
import { Status } from 'state/interfaces'

import { useAppSelector } from '../hooks'
import { AppState } from '../types'

export function useShowInfoAfter(): number {
  return useAppSelector((state) => state.competition.showInfoAfter)
}

export function useRulesAcceptedByAccount(account?: string): boolean | undefined {
  const rulesAcceptedAccounts = useAppSelector((state: AppState) => state.competition.rulesAccepted)

  return useMemo(() => {
    if (!account || !isAddress(account)) {
      return undefined
    }
    return rulesAcceptedAccounts?.[account]
  }, [rulesAcceptedAccounts, account])
}

export function useShowedDrive(): boolean {
  return useAppSelector((state: AppState) => state.competition.showedDrive)
}

export function useReferralModal(): { isOpen: boolean; data: { isRules: boolean } } | undefined {
  return useAppSelector((state: AppState) => state.competition.modals?.REFERRAL_AND_RULES)
}

export function useReferrerByAccount(account?: string): number | undefined {
  const referrers = useAppSelector((state: AppState) => state.competition.refCode)

  return useMemo(() => {
    if (!account || !isAddress(account)) {
      return undefined
    }
    return referrers?.[account]
  }, [referrers, account])
}

export function useTwitterIsBound(account?: string): {
  isTwitterBound: boolean
  status: Status
  username?: string
} {
  const defaultTwitterInfo = {
    isTwitterBound: false,
    status: Status.INITIAL,
  }
  const state = useAppSelector((state) => state.competition.twitter) || defaultTwitterInfo

  return useMemo(() => {
    if (!account || !isAddress(account)) {
      return defaultTwitterInfo
    }
    return state?.[account] || defaultTwitterInfo
  }, [state, account])
}

export function useIsRegistrationStarted(account?: string): boolean {
  const registrationStartedAccounts = useAppSelector((state) => state.competition.registrationStarted)

  return useMemo(() => {
    if (!account || !isAddress(account)) {
      return false
    }
    return registrationStartedAccounts?.[account]
  }, [registrationStartedAccounts, account])
}
